import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-product-name',
  templateUrl: './product-name.component.html',
  styleUrls: ['./product-name.component.css']
})
export class ProductNameComponent implements OnInit {

  productTitle: string;
  name: string;
  title: string;
  comments: string;

  constructor(private modalService: NgbModal) { }

  ngOnInit() {
    this.productTitle = this.productTitle;
    this.name = this.name;
    this.title = this. title;
    this.comments = this.comments;  
  }

  popupCloseButton() {
    this.modalService.dismissAll();
  }

}
